<div #pageTop>
  <app-wrapper size="xl">
    <app-content-row>
      <app-button-location-back (backClick)="goBack()">一覧に戻る</app-button-location-back>
    </app-content-row>
  </app-wrapper>

  <app-wrapper size="xl" isFitWithSmallScreen="true" @enter *ngIf="firstPageInitialized$ | async; else loadingProgress">
    <app-content-row>
      <app-card-content [showSeparator]="false">
        <!-- ▼ 特種なヘッダー -->
        <app-card-content-head>
          <div class="flex flex-wrap gap-2 items-center grow ">
            <div class="flex gap-2 items-center grow mr-auto">
              <mat-icon class="text-primary shrink-0">list_alt</mat-icon>
              <span class="text-lg leading-[1.5]">未分類のリスト({{ subjectName }})</span>
              <span class="px-1.5 py-1 bg-primary text-white rounded-full text-sm leading-[1]">{{ totalBookmarkCount }}</span>
            </div>
            <span class="ml-auto text-xs shrink-0">オーナー：自分</span>
          </div>
        </app-card-content-head>
        <!-- △ 特種なヘッダー -->

        <!-- 並び順はコメントアウト Start -->
        <!-- <app-wrapper size="fluid">
          <app-content-row>
            <div class="flex flex-wrap gap-y-2">
              <div class="mr-4 -mb-6">
                <mat-form-field appearance="outline" class="w-40 md:w-auto">
                  <mat-label>並び順</mat-label>
                  <mat-select [(value)]="selectedSortType" (selectionChange)="onChangeSortType()">
                    <mat-option *ngFor="let sortType of selectableSortTypes" [value]="sortType">
                      {{ sortType.displayName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <span class="mx-auto"></span>
            </div>
          </app-content-row>
        </app-wrapper> -->
        <!-- 並び順はコメントアウト End -->

        <app-wrapper size="fluid" [isFitWithSmallScreen]="totalBookmarkCount !== 0">
          <app-content-row>
            <app-content-no-data *ngIf="totalBookmarkCount === 0">
              <span>お気に入りされている問題がありません</span>
            </app-content-no-data>
            <ng-container *ngIf="totalBookmarkCount != null && totalBookmarkCount !== 0">
              <div>
                <!-- 英語の検索結果 -->
                <div class="" *ngIf="subjectId === ENGLISH_SUBJECT_ID">
                  <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                    <app-english-problems
                      [readableEnglishProblems]="readableEnglishProblems$ | async"
                      (problemClick)="showProblemDetail($event)"
                      [subjectId]="SubjectId.ENGLISH"
                      [bookmarkedAllFlag]="this.bookmarkedAllFlag"
                      [isTrial]="(signedInUser$ | async).isTrial"
                      [disabled]="false"
                    ></app-english-problems>
                  </div>
                </div>

                <!-- 数学の検索結果 -->
                <div class="" *ngIf="subjectId === MATH_SUBJECT_ID">
                  <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                    <app-science-problems
                      [readableScienceProblems]="readableMathProblems$ | async"
                      (problemClick)="showProblemDetail($event)"
                      [subjectId]="SubjectId.MATH"
                      [bookmarkedAllFlag]="this.bookmarkedAllFlag"
                      [isTrial]="(signedInUser$ | async).isTrial"
                      [disabled]="false"
                    ></app-science-problems>
                  </div>
                </div>

                <!-- 国語の検索結果 -->
                <div class="" *ngIf="subjectId === NATIONAL_LANGUAGE_SUBJECT_ID">
                  <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                    <app-national-language-problems
                      [readableNationalLanguageProblems]="readableNationalLanguageProblems$ | async"
                      (problemClick)="showProblemDetail($event)"
                      [subjectId]="SubjectId.NATIONAL_LANGUAGE"
                      [bookmarkedAllFlag]="this.bookmarkedAllFlag"
                      [isTrial]="(signedInUser$ | async).isTrial"
                      [disabled]="false"
                    ></app-national-language-problems>
                  </div>
                </div>

                <!-- 物理の検索結果 -->
                <div class="" *ngIf="subjectId === PHYSICS_SUBJECT_ID">
                  <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                    <app-science-problems
                      [readableScienceProblems]="readablePhysicsProblems$ | async"
                      (problemClick)="showProblemDetail($event)"
                      [subjectId]="SubjectId.PHYSICS"
                      [bookmarkedAllFlag]="this.bookmarkedAllFlag"
                      [isTrial]="(signedInUser$ | async).isTrial"
                      [disabled]="false"
                    ></app-science-problems>
                  </div>
                </div>

                <!-- 化学の検索結果 -->
                <div class="" *ngIf="subjectId === CHEMISTRY_SUBJECT_ID">
                  <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                    <app-science-problems
                      [readableScienceProblems]="readableChemistryProblems$ | async"
                      (problemClick)="showProblemDetail($event)"
                      [subjectId]="SubjectId.CHEMISTRY"
                      [bookmarkedAllFlag]="this.bookmarkedAllFlag"
                      [isTrial]="(signedInUser$ | async).isTrial"
                      [disabled]="false"
                    ></app-science-problems>
                  </div>
                </div>

                <!-- 生物の検索結果 -->
                <div class="" *ngIf="subjectId === BIOLOGY_SUBJECT_ID">
                  <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                    <app-science-problems
                      [readableScienceProblems]="readableBiologyProblems$ | async"
                      (problemClick)="showProblemDetail($event)"
                      [subjectId]="SubjectId.BIOLOGY"
                      [bookmarkedAllFlag]="this.bookmarkedAllFlag"
                      [isTrial]="(signedInUser$ | async).isTrial"
                      [disabled]="false"
                    ></app-science-problems>
                  </div>
                </div>

                <!-- 日本史の検索結果 -->
                <div class="" *ngIf="subjectId === JAPANESE_HISTORY_SUBJECT_ID">
                  <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                    <app-history-problems
                      [readableHistoryProblems]="readableJapaneseHistoryProblems$ | async"
                      (problemClick)="showProblemDetail($event)"
                      [subjectId]="SubjectId.JAPANESE_HISTORY"
                      [bookmarkedAllFlag]="this.bookmarkedAllFlag"
                      [isTrial]="(signedInUser$ | async).isTrial"
                      [disabled]="false"
                    ></app-history-problems>
                  </div>
                </div>

                <!-- 世界史の検索結果 -->
                <div class="" *ngIf="subjectId === WORLD_HISTORY_SUBJECT_ID">
                  <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                    <app-history-problems
                      [readableHistoryProblems]="readableWorldHistoryProblems$ | async"
                      (problemClick)="showProblemDetail($event)"
                      [subjectId]="SubjectId.WORLD_HISTORY"
                      [bookmarkedAllFlag]="this.bookmarkedAllFlag"
                      [isTrial]="(signedInUser$ | async).isTrial"
                      [disabled]="false"
                    ></app-history-problems>
                  </div>
                </div>

                <!-- 地理の検索結果 -->
                <div class="" *ngIf="subjectId === GEOGRAPHY_SUBJECT_ID">
                  <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                    <app-science-problems
                      [readableScienceProblems]="readableGeographyProblems$ | async"
                      (problemClick)="showProblemDetail($event)"
                      [subjectId]="SubjectId.GEOGRAPHY"
                      [bookmarkedAllFlag]="this.bookmarkedAllFlag"
                      [isTrial]="(signedInUser$ | async).isTrial"
                      [disabled]="false"
                    ></app-science-problems>
                  </div>
                </div>

                <!-- 政治・経済の検索結果 -->
                <div class="" *ngIf="subjectId === POLITICAL_ECONOMY_SUBJECT_ID">
                  <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                    <app-science-problems
                      [readableScienceProblems]="readablePoliticalEconomyProblems$ | async"
                      (problemClick)="showProblemDetail($event)"
                      [subjectId]="SubjectId.POLITICAL_ECONOMY"
                      [bookmarkedAllFlag]="this.bookmarkedAllFlag"
                      [isTrial]="(signedInUser$ | async).isTrial"
                      [disabled]="false"
                    ></app-science-problems>
                  </div>
                </div>

                <!-- 推薦・総合の検索結果 -->
                <div class="" *ngIf="subjectId === SPECIAL_ADMISSIONS_SUBJECT_ID">
                  <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                    <app-science-problems
                      [readableScienceProblems]="readableSpecialAdmissionsProblems$ | async"
                      (problemClick)="showProblemDetail($event)"
                      [subjectId]="SubjectId.SPECIAL_ADMISSIONS"
                      [bookmarkedAllFlag]="this.bookmarkedAllFlag"
                      [isTrial]="(signedInUser$ | async).isTrial"
                      [disabled]="false"
                    ></app-science-problems>
                  </div>
                </div>

                <!-- 問題取得中のプログレス -->
                <div class="progress-48" [@fadeInOut]="bookmarkSearching$ | async">
                  <mat-spinner [diameter]="48"></mat-spinner>
                </div>

                <div class="mt-4">
                  <app-paginator
                    [currentPage]="currentPage"
                    [totalItemCount]="totalBookmarkCount"
                    [pageSize]="paginationPageSize"
                    [windowSize]="paginationWindowSize"
                    (pageChange)="selectPage($event)"
                  ></app-paginator>
                </div>
              </div>
            </ng-container>
          </app-content-row>
        </app-wrapper>
      </app-card-content>
    </app-content-row>
  </app-wrapper>

  <ng-template #loadingProgress>
    <div class="progress-48">
      <mat-spinner [diameter]="48"></mat-spinner>
    </div>
  </ng-template>
</div>
